import { render, staticRenderFns } from "./NationalityProfileWidget.vue?vue&type=template&id=32137084&scoped=true"
import script from "./NationalityProfileWidget.vue?vue&type=script&lang=js"
export * from "./NationalityProfileWidget.vue?vue&type=script&lang=js"
import style0 from "./NationalityProfileWidget.vue?vue&type=style&index=0&id=32137084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32137084",
  null
  
)

export default component.exports